<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" :inline="true" label-width="100px" :show-overflow-tooltip="true">
        <el-form-item label="用户昵称" prop="nickname">
          <el-input v-model="queryParams.nickname" placeholder="请输入用户昵称" style="width: 240px" clearable  @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item label="登录IP" prop="ip">
          <el-input v-model="queryParams.ip" placeholder="请输入登录IP" clearable style="width: 240px"   @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item label="登录方式" prop="loginType">
          <el-select v-model="queryParams.loginType" placeholder="登录方式" clearable  >
            <el-option v-for="dict in dict.type.login_type" :key="dict.value" :label="dict.label" :value="dict.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="是否禁用" prop="isDisable">
          <el-select v-model="queryParams.isDisable" placeholder="请选择是否禁用" style="width: 240px"  clearable @change="handleQuery">
            <el-option :value="1" label="是">是</el-option>
            <el-option :value="0" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最近登录时间" >
          <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd"  style="width: 240px"  type="daterange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" :columns="columns"></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table border :data="userList" v-loading="loading" >
      <!-- 表格列 -->
      <el-table-column prop="linkAvatar" label="用户头像" align="center" width="100" v-if="columns.linkAvatar.visible">
        <template slot-scope="scope">
          <img v-if="scope.row.loginType === 2" :src="scope.row.avatar" width="40" height="40" referrerpolicy="no-referrer" alt=""/>
          <img v-else :src="scope.row.avatar" width="40" height="40" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="用户昵称" align="center" min-width="140" v-if="columns.nickname.visible">
        <template slot-scope="scope">
          <a class="link-type" style="cursor:pointer" @click="handleViewData(scope.row)">{{ scope.row.nickname }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="loginType" label="登录方式" align="center" min-width="100" v-if="columns.loginType.visible">
        <template slot-scope="scope">
          <dict-tag :options="dict.type.login_type" :value="scope.row.loginType"/>
        </template>
      </el-table-column>
      <el-table-column prop="roleList" label="用户角色" align="center" min-width="90px" v-if="columns.roleList.visible">
        <template slot-scope="scope">
          <el-tag v-for="(item, index) of splitUserName(scope.row.roleName)" :key="index" style="margin-right:4px;margin-top:4px">
            {{ item }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isDisable" label="禁用" align="center" min-width="100" >
        <template slot-scope="scope">
          <el-switch v-hasPermi="['system:user:edit']" v-model="scope.row.isDisable" active-color="#13ce66" inactive-color="#F4F4F5" :active-value="1" :inactive-value="0"
                     @change="changeDisable(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column prop="ipAddr" label="登录ip" align="center" min-width="140" v-if="columns.ipAddr.visible"/>
      <el-table-column prop="ipSource" label="登录地址" align="center" min-width="140" v-if="columns.ipSource.visible"/>
      <el-table-column prop="createTime" label="创建时间" min-width="200" align="center" v-if="columns.createTime.visible">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" label="上次登录时间" min-width="200" align="center" v-if="columns.lastLoginTime.visible">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.lastLoginTime | dateTime }}</span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button v-hasPermi="['system:user:edit']" type="text" size="mini" icon="el-icon-edit" @click="openEditModel(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 修改对话框 -->
    <el-dialog title="修改用户" :visible.sync="open" width="400px" :close-on-click-modal="false" >
      <el-form ref="userForm" label-width="90px" :model="userForm" :rules="rules">
        <el-form-item label="用户昵称" prop="nickname">
          <el-input v-model="userForm.nickname"  />
        </el-form-item>
        <el-form-item label="用户角色" prop="roleIdList">
          <el-checkbox-group v-model="userForm.roleIdList">
            <el-checkbox
              v-for="item of userRoleList"
              :key="item.roleId"
              :label="item.roleId"
            >
              {{ item.roleName }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="editUserRole">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <!-- 用户详情抽屉 -->
    <user-view-drawer ref="userViewRef" />
  </div>
</template>

<script>
import UserViewDrawer from "./view"
import {
  getUserList,
  updateUserDisable,
  updateUserRole,
  getUsersRoleList
} from "@/api/system/user";
export default {
  created() {
    this.getList();
  },
  dicts: ["login_type"],
  components: { UserViewDrawer },
  data: function() {
    return {
      loading: true,
      showSearch:true,
      open: false,
      userForm: {
        userInfoId: null,
        nickname: "",
        roleIdList: []
      },
      rules: {
        nickname: [
          { required: true, message: "请输入昵称", trigger: "blur" }
        ],
        roleIdList: [
          { required: true, message: "请选择角色", trigger: "blur" }
        ]
      },
      userRoleList: [],
      roleIdList: [],
      userList: [],
      dateRange: [],
      // 查询条件
      queryParams: {
        current: 1,
        size: 10,
        loginType: null,
        isDisable: null,
        ip: null,
        nickname: null,
        startTime:null,
        endTime:null,
      },
      // 列信息
      columns: {
        linkAvatar: { label: '用户头像', visible: true },
        nickname: { label: '用户昵称', visible: true },
        loginType: { label: '登录方式', visible: true },
        roleList: { label: '用户角色', visible: true },
        ipAddr: { label: '登录ip', visible: true },
        ipSource: { label: '登录地址', visible: true },
        createTime: { label: '创建时间', visible: true },
        lastLoginTime: { label: '上次登录时间', visible: true }
      },
      total: 0
    };
  },
  methods: {
    splitUserName(names){
      return names.split(",");
    },
    handleQuery(){
      this.queryParams.current = 1;
      this.getList();
    },
    resetQuery(){
      this.dateRange = [];
      this.queryParams.startTime=undefined;
      this.queryParams.endTime=undefined;
      this.resetForm("queryForm");
      this.handleQuery()
    },
    changeDisable(user) {
      let oper = user.isDisable === 0 ? "启用" : "禁用";
      let data = {
        id: user.userInfoId,
        yesOrNot: user.isDisable
      };
      updateUserDisable(data).then(res => {
        if (res.flag) {
          this.$modal.msgSuccess(oper + "成功");
          this.getList();
        }
      });
    },
    reset() {
      this.userForm = {
        userInfoId: undefined,
        nickname: undefined,
        roleIdList: []
      }
      this.resetForm('userForm')
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    openEditModel(user) {
      this.reset();
      this.roleIdList=[];
      this.userForm = JSON.parse(JSON.stringify(user));
      if(this.userForm.roleId){
        this.userForm.roleId.split(",").forEach(item=>{
          this.roleIdList.push(parseInt(item));
        })
      }
      this.$set(this.userForm,"roleIdList",this.roleIdList);
      this.open = true;
    },
    editUserRole() {
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          updateUserRole(this.userForm).then(res => {
            if (res.flag) {
              this.$modal.msgSuccess(res.msg);
              this.getList();
            } else {
              this.$modal.msgError(res.msg);
            }
            this.open = false;
          });        } else {
          return false;
        }
      });
    },
    getList() {
      this.loading = true;
      if( Array.isArray(this.dateRange) && this.dateRange.length>0){
        this.queryParams.startTime=this.dateRange[0];
        this.queryParams.endTime=this.dateRange[1];
      }
      getUserList(this.queryParams).then(res => {
        this.userList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
      getUsersRoleList().then(res => {
        this.userRoleList = res.data;
      });
    },
    /** 详情按钮操作 */
    handleViewData(row) {
      this.$refs.userViewRef.open(row.userInfoId)
    },
  }
};
</script>
